import { axiosClient } from '../axiosClient';
import { AITrainingStatus } from './types';

type Params = {
  status: AITrainingStatus | null;
  datasetIds: number[];
};

export async function updateAITrainingStatus(body: Params) {
  return axiosClient.post<Record<string, unknown>>(
    '/instastack/training-v3/review-status',
    {
      datasetItemIds: body.datasetIds,
      reviewStatus: body.status,
    }
  );
}
